import { connect } from 'react-redux'
import { splitSet } from '../../actions/project/set'
import { IconElement } from '../../components/FrameMenu/index'

const mapStateToProps = () => ({
  isSelected: false,
})

const mapDispatchToProps = dispatch => ({
  action: () => dispatch(splitSet()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconElement)



// WEBPACK FOOTER //
// ./src/containers/FrameMenu/Split.js